import { render, staticRenderFns } from "./ShoeProducts.vue?vue&type=template&id=500553b0&scoped=true"
import script from "./ShoeProducts.vue?vue&type=script&lang=js"
export * from "./ShoeProducts.vue?vue&type=script&lang=js"
import style0 from "./ShoeProducts.vue?vue&type=style&index=0&id=500553b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500553b0",
  null
  
)

export default component.exports